import { useEffect } from 'react';

import useRoleSettings from '@/hooks/useRoleSettings';
import { hydrateRoleDefaults } from '@/services/userSettingsStore';

/**
 * Installs the reader's role defaults into the settings store.
 *
 * Runs app-wide rather than per page so a defaulted setting read during the
 * first render of any page already has the role's value underneath it, and so
 * saving a default for your own role takes effect without a reload.
 */
const useRoleSettingsSync = ({ enabled }: { enabled: boolean }) => {
  const { currentRole, isLoaded, settingsForRole } = useRoleSettings({ enabled });

  useEffect(() => {
    if (!isLoaded) return;

    hydrateRoleDefaults(settingsForRole(currentRole));
  }, [currentRole, isLoaded, settingsForRole]);
};

export default useRoleSettingsSync;
